import { inject, Injectable } from '@angular/core';
import { FormControl, FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Merchant } from '@shared/models';

export type MerchantOverviewFormMode = 'view' | 'edit';

export interface MerchantOverviewFormControls {
  Name: FormControl<string | null>;
  BasePrice: FormControl<number | null>;
  PerSmsprice: FormControl<number | null>;
  SalesRepresentativeId: FormControl<number | null>;
}

export type MerchantOverviewFormGroup = FormGroup<MerchantOverviewFormControls>;

@Injectable()
export class MerchantOverviewFormService {
  private readonly fb = inject(NonNullableFormBuilder);

  private readonly mode$$ = new BehaviorSubject<MerchantOverviewFormMode>('view');
  readonly mode$ = this.mode$$.asObservable();

  private readonly merchantOverviewForm: MerchantOverviewFormGroup = this.fb.group<MerchantOverviewFormControls>({
    Name: this.fb.control<string | null>(null, { validators: [Validators.required] }),
    BasePrice: this.fb.control<number | null>(null, { validators: [Validators.required, Validators.min(0)] }),
    PerSmsprice: this.fb.control<number | null>(null, { validators: [Validators.required, Validators.min(0)] }),
    SalesRepresentativeId: this.fb.control<number | null>(null),
  });

  getForm(): MerchantOverviewFormGroup {
    return this.merchantOverviewForm;
  }

  getMode(): MerchantOverviewFormMode {
    return this.mode$$.value;
  }

  initializeForView(merchant: Merchant): void {
    this.mode$$.next('view');
    this.resetTo(merchant);
    this.merchantOverviewForm.disable();
  }

  initializeForEdit(merchant: Merchant): void {
    this.mode$$.next('edit');
    this.resetTo(merchant);
    this.merchantOverviewForm.enable();
  }

  private resetTo(merchant: Merchant): void {
    this.merchantOverviewForm.reset({
      Name: merchant.Name ?? null,
      BasePrice: merchant.BasePrice ?? null,
      PerSmsprice: merchant.PerSmsprice ?? null,
      SalesRepresentativeId: merchant.SalesRepresentativeId ?? null,
    });
  }
}
